import { createContext, useContext } from "react";
import type { User } from "../../types/user";

interface UserContextType {
  user: User;
  token: string;
  refresh_token: string;
  logout: () => Promise<void>;
  isLoggingOut: boolean;
  refetchProfile: VoidFunction;
}

const userContext = createContext<UserContextType>({
  user: {
    id: "",
    code: "",
    name: "",
    phone_number: "",
    balance: 0,
    locked: false,
    state_change_reason: "",
    info_locked: false,
    date_joined: "",
    is_self: false,
    has_password: false,
    use_password: false,
    merchant: null,
    marketer: null,
    hint_seen: false,
    inviter_name: null,
  },
  token: "",
  refresh_token: "",
  logout: async () => {},
  isLoggingOut: false,
  refetchProfile: () => {},
});

const useUserContext = () => {
  const context = useContext(userContext);
  if (!context) {
    throw new Error("useUserContext must be used within a UserProvider");
  }
  return context;
};

export { userContext, useUserContext };
